export const getStyleType = (geotype) => {
  if (geotype === 'POINT' || geotype === 'MULTIPOINT' || geotype === 'TREE')
    return 'circle'
  else if (
    geotype === 'LINESTRING' ||
    geotype === 'MULTILINESTRING' ||
    geotype === 'OUTLINE'
  )
    return 'line'
  else if (geotype === 'POLYGON' || geotype === 'MULTIPOLYGON') return 'fill'
}

export const getConfigType = (geotype) => {
  if (geotype === 'POINT' || geotype === 'MULTIPOINT' || geotype === 'TREE')
    return 'vector'
  else if (
    geotype === 'LINESTRING' ||
    geotype === 'MULTILINESTRING' ||
    geotype === 'OUTLINE'
  )
    return 'line'
  else if (geotype === 'POLYGON' || geotype === 'MULTIPOLYGON') return 'fill'
}

export const getLayout = (geotype, visibility = 'none') => {
  if (geotype === 'POINT' || geotype === 'MULTIPOINT' || geotype === 'TREE') {
    return {
      visibility: visibility,
    }
  } else if (
    geotype === 'LINESTRING' ||
    geotype === 'MULTILINESTRING' ||
    geotype === 'OUTLINE'
  ) {
    return {
      visibility: visibility,
      'line-join': 'round',
      'line-cap': 'round',
    }
  } else if (geotype === 'POLYGON' || geotype === 'MULTIPOLYGON') {
    return {
      visibility: visibility,
    }
  }
}

function darkenHexColor(hex, factor) {
  // Remove the leading '#' if present
  hex = hex.replace('#', '')

  // Convert the hex string to RGB values
  let r = parseInt(hex.substring(0, 2), 16)
  let g = parseInt(hex.substring(2, 4), 16)
  let b = parseInt(hex.substring(4, 6), 16)

  // Apply the darkening factor (0 = black, 1 = original color)
  r = Math.max(0, Math.min(255, Math.floor(r * factor)))
  g = Math.max(0, Math.min(255, Math.floor(g * factor)))
  b = Math.max(0, Math.min(255, Math.floor(b * factor)))

  // Convert the modified RGB values back to a hex string
  const darkenedHex =
    '#' +
    r.toString(16).padStart(2, '0') +
    g.toString(16).padStart(2, '0') +
    b.toString(16).padStart(2, '0')

  return darkenedHex
}

export const getPaint = (geotype, color = '', key = '') => {
  if (color === '') {
    var c = [
      'case',
      ['has', 'selected'],
      ['get', 'selected'],
      ['has', 'hex'],
      ['get', 'hex'],
      '#123456',
    ]
  } else {
    if (geotype === 'OUTLINE') color = darkenHexColor(color, 0.2)
    var c = [
      'case',
      ['has', 'selected'],
      ['get', 'selected'],
      ['has', 'hex'],
      ['get', 'hex'],
      ['to-color', color],
    ]
  }

  // Default opacity and stroke settings
  let opacity = 0.5
  let strokeWidth = 2

  // If the key is 'hydra_wd_vw', modify opacity and stroke width based on the 'rating' field
  // if (key === 'hydra_wd_vw') {
  //     opacity = ['case', ['==', ['get', 'rating'], true], 0.8, 0.2];
  //     strokeWidth = ['case', ['==', ['get', 'rating'], true], 7, 1];
  // }

  // If the key is 'rated_wd_mat_vw', modify opacity and stroke width based on the 'rating' field
  if (key === 'rated_wd_mat_vw' || key === 'rated_gsa_mat_vw' || key === 'provisional_crops_2023') {
    opacity = 0.8
    strokeWidth = 2
  }

  if (geotype === 'TREE') {
    return {
      'circle-color': c,
      'circle-radius': 4,
      'circle-opacity': opacity,
      'circle-stroke-width': 0.5,
      'circle-stroke-color': c,
    }
  } else if (geotype === 'POINT' || geotype === 'MULTIPOINT') {
    return {
      'circle-color': c,
      'circle-radius': 14,
      'circle-opacity': opacity,
      'circle-stroke-width': strokeWidth,
      'circle-stroke-color': c,
    }
  } else if (
    geotype === 'LINESTRING' ||
    geotype === 'MULTILINESTRING' ||
    geotype === 'OUTLINE'
  ) {
    return {
      'line-color': c,
      'line-width': strokeWidth,
      // 'line-dasharray': [2, 4],  // Dash pattern: 2px dash, 4px space
    }
  } else if (geotype === 'POLYGON' || geotype === 'MULTIPOLYGON') {
    return {
      'fill-color': c,
      'fill-opacity': opacity,
      'fill-outline-color': c,
    }
  }
}

export const getRanchPaint = (geotype, color = '') => {
  if (color === '') {
    var c = [
      'case',
      ['has', 'selected'],
      ['get', 'selected'],
      ['has', 'hex'],
      ['get', 'hex'],
      '#123456',
    ]
  } else {
    var c = [
      'case',
      ['has', 'selected'],
      ['get', 'selected'],
      ['has', 'hex'],
      ['get', 'hex'],
      ['to-color', color],
    ]
  }
  if (geotype === 'TREE') {
    return {
      'circle-color': c,
      'circle-radius': 4,
      'circle-opacity': 0.8,
      'circle-stroke-width': 0.5,
      'circle-stroke-color': c,
    }
  } else if (geotype === 'POINT' || geotype === 'MULTIPOINT') {
    return {
      'circle-color': c,
      'circle-radius': 8,
      'circle-opacity': 0.5,
      'circle-stroke-width': 2,
      'circle-stroke-color': c,
    }
  } else if (
    geotype === 'LINESTRING' ||
    geotype === 'MULTILINESTRING' ||
    geotype === 'OUTLINE'
  ) {
    return {
      'line-color': c,
      'line-width': 2,
    }
  } else if (geotype === 'POLYGON' || geotype === 'MULTIPOLYGON') {
    return {
      'fill-color': c,
      'fill-opacity': 0.2,
      'fill-outline-color': c,
    }
  }
}

export const getConfig = (alias, group, geotype, sourceid, data) => {
  var config = {
    id: alias,
    directory: 'Layers',
    group: group,
    metadata: {
      lazyLoading: true,
      source: {
        id: sourceid,
        type: getConfigType(geotype),
        data: data,
      },
    },
  }
  if (geotype !== 'OUTLINE' && geotype !== 'LABEL') {
    config['children'] = true
  } else {
    config['hidden'] = true
    config['parent'] = alias.split('_')[0]
  }
  return config
}

export const getLabelConfig = (alias, group, sourceid, geotype, data) => {
  return {
    id: alias,
    directory: 'Layers',
    group: group,
    hidden: true,
    parent: alias.split('_')[0],
    metadata: {
      lazyLoading: true,
      source: {
        id: sourceid,
        type: getConfigType(geotype),
        data: data,
      },
    },
  }
}

export const getTextField = (label, name={}) => {
  if (label.length === 0) {
    return ['format', '']
  } else {
    var textField = ['format']
    
    label.forEach(function (item) {
      if (Object.keys(name).includes(item)) {
        textField.push([
          "concat", 
          `District No : `, 
          ["get", item]
        ]);
      } else {
        // Otherwise, just use "get"
        textField.push(["get", item]);
      }

      textField.push({ "font-scale": 1 });
      textField.push("\n");
    });

    return textField;
  }
};
